// extracted by mini-css-extract-plugin
module.exports = {"testimonialWrap":"_2Qj-W","rightGradient":"_2-cQx","heading":"GFvO2"};